import { Zap } from 'lucide-react';
import { StageTriggerCard } from '../StageTriggerCard';
import type { StageTriggerData } from '../types';

export interface StageTriggerSectionProps {
  triggers: StageTriggerData[];
  className?: string;
}

export function StageTriggerSection({
  triggers,
  className,
}: StageTriggerSectionProps) {
  if (triggers.length === 0) return null;

  return (
    <div className={className ?? 'flex flex-col gap-2.5 px-6'}>
      <div className="flex items-center gap-1.75">
        <Zap className="size-5 text-black" />
        <span className="text-xs leading-4 font-semibold text-black">
          TRIGGERS
        </span>
      </div>
      {triggers.map((trigger, idx) => (
        <StageTriggerCard key={idx} {...trigger} />
      ))}
    </div>
  );
}
